import { EOposNumberOfExams, EVerticalNames, OPOS_NUMBER_OF_EXAMS } from '@constants';
import { IUserInfo, IUser } from '@sdk/contracts';
import { Form, FormInstance, Radio, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { FileAttachment } from '../FileAttachment';
import { ExamGroupSelector } from '../Form/ExamGroupSelector';

import { Wrapper, TitleWrapper } from './OposFormContent.styles';

import { AutonomousCommunitySelector } from '@/components/Form';

type OposFormContentProps = {
  form: FormInstance<IUserInfo>;
  profile?: IUser;
  isManager: boolean;
};

export const OposFormContent: React.FC<OposFormContentProps> = ({ form, profile, isManager }) => {
  const { t } = useTranslation(['DefaultTranslations', 'StudentProfileConfigurationTranslations']);
  const userInfo = profile?.userInfo;
  const data = userInfo?.oposUserInfo;

  const watchedNumberOfExams = Form.useWatch(['oposUserInfo', 'numberOfExams'], form);
  const hasExams = watchedNumberOfExams && watchedNumberOfExams !== EOposNumberOfExams.ZERO;

  const handleChangeNumberOfExams = (value: EOposNumberOfExams) => {
    form.setFieldsValue({
      oposUserInfo: {
        ...form.getFieldValue('oposUserInfo'),
        numberOfExams: value
      }
    });
  };

  return (
    <Wrapper>
      {isManager && <TitleWrapper>{t(EVerticalNames.OPOS)}</TitleWrapper>}
      <Form.Item
        name={['oposUserInfo', 'autonomousCommunity']}
        label={t('StudentProfileConfigurationTranslations:AUTONOMOUS_COMMUNITY_WORK')}
        initialValue={data?.autonomousCommunity}>
        <AutonomousCommunitySelector allowClear />
      </Form.Item>
      <Form.Item
        name={['examGroups']}
        label={t('StudentProfileConfigurationTranslations:EXAM_GROUPS')}
        initialValue={userInfo?.examGroups}>
        <ExamGroupSelector
          value={userInfo?.examGroups}
          vertical={EVerticalNames.OPOS}
          onChange={(value: string[] | string) =>
            form.setFieldsValue({ examGroups: Array.isArray(value) ? value : [value] })
          }
        />
      </Form.Item>
      <Form.Item
        name={['oposUserInfo', 'hasMasterDegree']}
        label={t('StudentProfileConfigurationTranslations:HAS_MASTER_DEGREE')}
        initialValue={data?.hasMasterDegree}>
        <Radio.Group
          onChange={e =>
            form.setFieldsValue({
              oposUserInfo: {
                ...form.getFieldValue('oposUserInfo'),
                hasMasterDegree: e.target.value
              }
            })
          }>
          <Radio value={true}>{t('YES')}</Radio>
          <Radio value={false}>{t('NO')}</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item
        name={['oposUserInfo', 'numberOfExams']}
        label={t('StudentProfileConfigurationTranslations:NUMBER_OF_EXAMS')}
        initialValue={data?.numberOfExams}>
        <Select
          placeholder={t('StudentProfileConfigurationTranslations:SELECT_NUMBER_OF_EXAMS')}
          onChange={handleChangeNumberOfExams}
          options={OPOS_NUMBER_OF_EXAMS.map(exam => ({
            value: exam,
            label: t(`StudentProfileConfigurationTranslations:${exam}`)
          }))}
        />
      </Form.Item>
      {hasExams && (
        <Form.Item
          name={['oposUserInfo', 'examsCertificates']}
          label={t('StudentProfileConfigurationTranslations:EXAMS_CERTIFICATES')}>
          <FileAttachment />
        </Form.Item>
      )}
    </Wrapper>
  );
};
